import { render } from "./contactSidebar.vue?vue&type=template&id=7722732d&scoped=true"
import script from "./contactSidebar.vue?vue&type=script&lang=js"
export * from "./contactSidebar.vue?vue&type=script&lang=js"

import "./contactSidebar.vue?vue&type=style&index=0&id=7722732d&scoped=true&lang=css"

import exportComponent from "C:\\Users\\amaan\\encanto-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7722732d"]])

export default __exports__